import React, { useState, useContext } from 'react'
import { HeaderBackToLabelFontType } from '../../../UI/Typo'
import ComponentSpacing from '../../../containers/ComponentSpacing'
import { ReactComponent as CloseImg } from '../../../../assets/icons/close-calc.svg'
import { TabPicker } from '../../../tabPicker'
import { ReactComponent as MaterialTabIcon } from '../../../../assets/icons/vegetables.svg'
import { ReactComponent as ArbeitTabIcon } from '../../../../assets/icons/labour.svg'
import { ReactComponent as TotalTabIcon } from '../../../../assets/icons/roi.svg'
import { CalculatorContext } from '../../../../providers/calculator'
import { PaybackCalculatorConfigureMachineArbeitTab } from './arbeit'
import { PaybackCalculatorConfigureMachineTotalTab } from './total'
import { PaybackCalculatorMaterialTab } from '../tabs/material'
import v from '../../../../helpers/vocabulary'

export function PaybackCalculatorConfigureMachine({ onClose }) {
  const { selectedMachineTitle } = useContext(CalculatorContext)

  const [selectedTabIndex, setSelectedTabIndex] = useState(0)

  var tabs = [
    {
      name: v.translate('calculator.savings.tabMaterial.tabTitle'),
      Icon: MaterialTabIcon,
      component: PaybackCalculatorMaterialTab
    },
    {
      name: v.translate('calculator.savings.tabTime.tabTitle'),
      Icon: ArbeitTabIcon,
      component: PaybackCalculatorConfigureMachineArbeitTab
    },
    {
      name: v.translate('calculator.savings.tabProcessing.tabTitle'),
      Icon: TotalTabIcon,
      component: PaybackCalculatorConfigureMachineTotalTab
    }
  ].map((tab, index) => ({
    ...tab,
    onClick: () => setSelectedTabIndex(index),
    selected: index === selectedTabIndex
  }))

  const SelectedTab = tabs[selectedTabIndex].component

  return (
    <>
      <ComponentSpacing
        pt="sm"
        pb="sm"
        pl="md"
        pr="md"
        className="vivid-blue-background et-payback-modal-header-start"
        id="et-configure-machine-1"
      >
        <div className="et-payback-calculator-modal-header-title ">

          <HeaderBackToLabelFontType noSpace>
            {' '}
            {v.translate('calculator.savings.title', {
              selectedAnlikerMachineOrHandcut: selectedMachineTitle
            })}
          </HeaderBackToLabelFontType>
          <CloseImg
            className="et-payback-calculator-modal-header-title-container-close-button"
            onClick={onClose}
          />
        </div>
      </ComponentSpacing>
      <ComponentSpacing
        pt="xs"
        pl="sm"
        pr="sm"
        className="vivid-blue-background et-payback-modal-header-middle"
        id="et-configure-machine-2"
      >
        <TabPicker {...{ tabs, selectedTabIndex }} />
      </ComponentSpacing>
      <ComponentSpacing
        pt="md"
        className="vivid-blue-background et-payback-modal-header-empty-space"
        id="et-configure-machine-3" />
      <SelectedTab />
    </>
    
  )
}



